const swiperTabsWithContent = {
    swiperInstance: null,
    init: () => {
        import("swiper/bundle").then(({ Swiper }) => {
            let domEls = document.querySelectorAll(
                ".js-swiper-tabs-with-content"
            );
            if (domEls) {
                const params = getSwiperParams();
                domEls.forEach((el) => {
                    swiperTabsWithContent.swiperInstance = new Swiper(
                        el,
                        params
                    );
                });
            }
        });
    },
};

const getSwiperParams = () => {
    return {
        watchOverflow: true,
        spaceBetween: 16,
        slidesPerView: "auto",
        //slidesPerView: 1.3,
        resizeObserver: true,
        a11y: true,
        slideToClickedSlide: true,
        /*navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },*/
        mousewheel: {
            forceToAxis: true
        },
        grabCursor: true,
        breakpoints: {
            768: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3,
            },
            1280: {
                slidesPerView: 4,
            },
        },
    }
}

export default swiperTabsWithContent;